
  @if(visible()){

    @if(displayLabel()){
      <mat-label class="jk-field-lable">{{label()}} </mat-label>
    }
    <table class="jk-row-border">
      <tr lines="none">
        <td colspan="3">
        </td>
      </tr>
      <tr lines="none">
        <td size="auto">
          <mat-label class="jk-field-lable">{{minText()}} </mat-label>
        </td>
        <td style="color:blue">
          |
        </td>
        <td size="auto">
          <mat-label class="jk-field-lable">{{maxText()}}</mat-label>
        </td>

      </tr>
    </table>
  }


